import React, { Component } from 'react';
import { reduxForm } from 'redux-form';
import { Grid, Form, Checkbox, Button } from 'semantic-ui-react';
import { AssignItemsToSite as FieldEnum } from 'Common/FieldEnum';
import { OrderPreferenceEnum } from 'Common/Constants/Enumeration/OrderPreferenceEnum';
import { caseInsensitiveFilter } from '../../../common/GridHelper';
import ReactTable from 'react-table';
import { TitledCard } from 'Components';
import { GenericFiltersContainer } from 'Components/filters/container';
import { ASSIGN_ITEMS_FORM_NAME } from 'Common/FormEnum';

class AssignItemsForm extends Component {
  state = {
    checkAllChecked: false,
    checkAllVendorOnly: false,
    checkAllVendorAllowed: false,
  };

  onFilteredChange = () => this.setState({ checkAllChecked: false });
  checkAllAccessClick = (e, data) => {
    const { modalData, filterValues, checkAllAction } = this.props;
    if (!data.checked) {
      this.setState({
        checkAllVendorOnly: data.checked,
        checkAllVendorAllowed: data.checked,
        checkAllChecked: data.checked,
      });
    } else if (data.checked) {
      this.setState({
        checkAllChecked: data.checked,
      });
    }
    checkAllAction(
      FieldEnum.CheckBox,
      data.checked,
      modalData.OrderPreferenceId,
      filterValues
    );
  };
  checkAllVendorClick = (e, data) => {
    const { modalData, filterValues, checkAllAction } = this.props;
    if (data.checked) {
      this.setState({
        checkAllVendorAllowed: data.checked,
        checkAllChecked: data.checked,
      });
    } else if (!data.checked) {
      this.setState({
        checkAllVendorAllowed: data.checked,
        checkAllVendorOnly: data.checked,
      });
    }
    checkAllAction(
      FieldEnum.VendorOrder,
      data.checked,
      modalData.OrderPreferenceId,
      filterValues
    );
  };
  checkAllVendorOnlyClick = (e, data) => {
    const { modalData, filterValues, checkAllAction } = this.props;
    if (data.checked) {
      this.setState({
        checkAllVendorOnly: data.checked,
        checkAllVendorAllowed: data.checked,
        checkAllChecked: data.checked,
      });
    } else if (!data.checked) {
      this.setState({
        checkAllVendorOnly: data.checked,
      });
    }
    checkAllAction(
      FieldEnum.VendorOnly,
      data.checked,
      modalData.OrderPreferenceId,
      filterValues
    );
  };
  render() {
    const {
      handleSubmit,
      assignItemsData,
      updateAssignItemData,
      modalData,
      loading,
      fields,
      handleChange,
      filterValues,
      clearFilters,
    } = this.props;

    const columns = [
      {
        Header: () => {
          return (
            <div className={'assignItemsListingHeader'}>
              <Checkbox
                checked={this.state.checkAllChecked}
                onClick={this.checkAllAccessClick}
              />
              {'    '}
              <label>Access</label>
            </div>
          );
        },
        accessor: FieldEnum.CheckBox,
        maxWidth: 80,
        Cell: ({ original }) => {
          return (
            <div style={{ textAlign: 'center' }}>
              <Checkbox
                checked={original.CheckBox}
                onClick={() => {
                  updateAssignItemData(
                    FieldEnum.CheckBox,
                    original,
                    modalData.OrderPreferenceId
                  );
                }}
              />
            </div>
          );
        },
        sortable: true,
      },
    ];
    if (modalData.OrderPreferenceId !== OrderPreferenceEnum.vendorOnly) {
      columns.push({
        Header: () => {
          return (
            <div className={'assignItemsListingHeader'}>
              <Checkbox
                checked={this.state.checkAllVendorAllowed}
                onClick={this.checkAllVendorClick}
              />{' '}
              <label>Distributor Allowed</label>
            </div>
          );
        },
        accessor: FieldEnum.VendorOrder,
        maxWidth: 130,
        Cell: ({ original }) => {
          return (
            <div style={{ textAlign: 'center' }}>
              <Checkbox
                checked={original.VendorOrder}
                onClick={() => {
                  updateAssignItemData(
                    FieldEnum.VendorOrder,
                    original,
                    modalData.OrderPreferenceId
                  );
                }}
              />
            </div>
          );
        },
        sortable: true,
      });
      columns.push({
        Header: () => {
          return (
            <div className={'assignItemsListingHeader'}>
              <Checkbox
                checked={this.state.checkAllVendorOnly}
                onClick={this.checkAllVendorOnlyClick}
              />{' '}
              <label>Distributor Only</label>
            </div>
          );
        },
        accessor: FieldEnum.VendorOnly,
        maxWidth: 120,
        Cell: ({ original }) => {
          return (
            <div style={{ textAlign: 'center' }}>
              <Checkbox
                checked={original.VendorOnly}
                onClick={() => {
                  updateAssignItemData(
                    FieldEnum.VendorOnly,
                    original,
                    modalData.OrderPreferenceId
                  );
                }}
              />
            </div>
          );
        },
        sortable: true,
      });
    }
    columns.push({
      Header: 'Item Code',
      accessor: 'ItemCode',
      filterable: true,
      sortable: true,
    });
    columns.push({
      Header: 'Description',
      accessor: 'ItemDescription',
      filterable: true,
      sortable: true,
    });

    return (
      <React.Fragment>
        <Form onSubmit={handleSubmit}>
          <TitledCard title={'Filter by'}>
            <Grid className="grid-spacing">
              <GenericFiltersContainer
                fields={fields}
                onChange={handleChange}
                filterValues={filterValues}
              />
            </Grid>
            <Grid.Row width={2}>
              <Grid.Column width={10} />
              <Grid.Column width={6}>
                <Button
                  className={'clear-filters-button'}
                  content="Clear Filters"
                  onClick={clearFilters}
                  type={'button'}
                />
              </Grid.Column>
            </Grid.Row>
          </TitledCard>
          <TitledCard>
            <Grid>
              <Grid.Row columns={1} className={'remove-spacing'}>
                <Grid.Column>
                  <ReactTable
                    style={{
                      maxHeight: '400px', // This will force the table body to overflow and scroll, since there is not enough room
                    }}
                    loading={loading}
                    defaultPageSize={20}
                    showPageSizeOptions={true}
                    minRows={0}
                    data={assignItemsData}
                    resizable={false}
                    className="-striped -highlight modalGrid"
                    defaultFilterMethod={caseInsensitiveFilter}
                    onFilteredChange={this.onFilteredChange}
                    columns={[
                      {
                        columns: columns,
                      },
                    ]}
                  />
                </Grid.Column>
              </Grid.Row>
            </Grid>
          </TitledCard>
        </Form>
      </React.Fragment>
    );
  }
}

export default reduxForm({
  form: ASSIGN_ITEMS_FORM_NAME,
})(AssignItemsForm);



// WEBPACK FOOTER //
// ./src/pages/sitesetup/components/AssignItemsForm.js